<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">{{!selectSubCategoria  ? 'Agregar' : 'Editar'}} SubCategoría</label>
      </header>
      <form [formGroup]="formSubCategoria" (ngSubmit)="onOperarSubCategoria()">
        <div class="form-group">
          <label class="small text-secondary" for="nit">Descripción Subcategoría</label>
          <input id="descripcion" formControlName="descripcion" type="text" class="form-control form-control-sm">
        </div>
        <!-- <div class="form-group">
          <label class="small text-secondary" for="nit">Descripción Requisitos</label>
          <input id="descripcion_requisitos" formControlName="descripcion_requisitos" type="text"
            class="form-control form-control-sm">
        </div> -->
        <div class="form-group">
          <button type="button" class="btn btn-primary w-100" (click)="onOpenModalGenerarHtml()">{{!selectSubCategoria
              ? 'Agregar' : 'Editar'}} descripción requisitos</button>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Categoría</label>
          <select class="form-control form-control-sm" id="categoria_id" formControlName="categoria_id">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" *ngFor="let option of categoria; let i = index" value="{{option?.categoria_id}}"
              [selected]="false">
              {{option?.descripcion}}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Aplica Alojamiento Hospedaje</label>
          <select class="form-control form-control-sm" id="aplica_alojamiento_hospedaje"
            formControlName="aplica_alojamiento_hospedaje">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Sí
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              No
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Aplica Documento Adjunto</label>
          <select class="form-control form-control-sm" id="aplica_documento_adjunto"
            formControlName="aplica_documento_adjunto">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Sí
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              No
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Aplica Registro Mercantíl</label>
          <select class="form-control form-control-sm" id="aplica_registro_mercantil"
            formControlName="aplica_registro_mercantil">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Sí
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              No
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Aplica Resolución MinTransporte</label>
          <select class="form-control form-control-sm" id="aplica_resolucion_mintransporte"
            formControlName="aplica_resolucion_mintransporte">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Sí
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              No
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Aplica Sostenibilidad Turística</label>
          <select class="form-control form-control-sm" id="aplica_sostenibilidad_turistica"
            formControlName="aplica_sostenibilidad_turistica">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Sí
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              No
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Aplica Turismo Aventura</label>
          <select class="form-control form-control-sm" id="aplica_turismo_aventura"
            formControlName="aplica_turismo_aventura">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Sí
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              No
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Permite Cambio Tipo RNT</label>
          <select class="form-control form-control-sm" id="permite_cambio_tipo_rnt"
            formControlName="permite_cambio_tipo_rnt">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Sí
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              No
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Estado</label>
          <select class="form-control form-control-sm" id="activo" formControlName="activo"
            [attr.disabled]="!selectSubCategoria ? '' : null">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Activo
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              Inactivo
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="font-weight-bold text-dark" for="nit">Actividades económicas (CIIU)</label>
          <br>
          <label class="CIIU">Código CIIU</label>
          <ng-container formArrayName="actividades_economicas">
            <ng-container *ngFor="let actividadesEconomicasForm of actividades_economicas.controls; let i = index;let last = last;">
                <div class="row mb-2" [formGroup]="actividadesEconomicasForm">
                    <div class="col-10">
                      <input id="descripcion" 
                             [matAutocomplete]="auto"
                             (click)="get()"
                             formControlName="valor" 
                             (ngModelChange)="onChangeSearch($event)" 
                             type="text" 
                             class="form-control form-control-sm">
                      
                      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                        <mat-option *ngFor="let option of actividad_economica" (click)="onSelectActividadEconomica(i)" value="{{option.codigo_actividad_economica}}">
                          {{option.desc_actividad_economica}}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                    <div class="col mt-1">
                      <img src="assets/icons/delete-black.png"
                            width="20"
                            height="20"
                            (click)="deleteActividadEconomica(i)">
                    </div>
                </div>
            </ng-container>
            
            <div class="form-group">
              <button class="btn btn-primary"
                      type="button"
                      (click)="addActividadEconomica()">
                      AGREGAR
              </button>
            </div>
          </ng-container>
        </div>
        
        <div class="form-group TiposolicitudClass">
          <label class="font-weight-bold text-dark" for="nit">Habilitar tipo de solicitud</label>
          <mat-selection-list class="TiposolicitudList" (selectionChange)="selectOpt($event)" formControlName="habilitatiposolicitud">
            <mat-list-option *ngFor="let item of tipoSolicitud" [value]="item.tipo_solicitud_id" >
              {{item.descripcion}}
            </mat-list-option>
          </mat-selection-list>
          <label class="font-weight-bold text-dark">Ingresa el mensaje de advertencia para los tipos de solicitudes que no están activados</label> 
          <mat-form-field class="w-100" appearance="fill">
            <textarea matInput placeholder="El mensaje" formControlName="denegar_tipo_solicitud_mensaje"></textarea>
          </mat-form-field>
        </div>
        <div class="form-row mt-5">
          <button type="button" class="btn btn-outline-primary border-0 m-auto"
            (click)="limpiaSubcategoria()">Limpiar</button>
          <button class="btn btn-primary m-auto " [disabled]="!formSubCategoria.valid" type="submit">{{!selectSubCategoria
            ? 'Agregar' : 'Editar'}}</button>
        </div>
      </form>
      
    </section>
    <section class="col-9 p-4 mt-5 mb-5">
      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Listado de SubCategorías</label>
        </div>
        <p>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </p>
      </div>

      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Descripción Subcategoría</label>
                  <input id="descripcion" formControlName="descripcion" type="text"
                    class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Categoría</label>
                  <select class="form-control form-control-sm" id="categoria_id" formControlName="categoria_id">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of categoria; let i = index" value="{{option?.categoria_id}}"
                      [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Aplica Alojamiento Hospedaje</label>
                  <select class="form-control form-control-sm" id="aplica_alojamiento_hospedaje"
                    formControlName="aplica_alojamiento_hospedaje">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Sí
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Aplica Documento Adjunto</label>
                  <select class="form-control form-control-sm" id="aplica_documento_adjunto"
                    formControlName="aplica_documento_adjunto">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Sí
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Aplica Registro Mercantíl</label>
                  <select class="form-control form-control-sm" id="aplica_registro_mercantil"
                    formControlName="aplica_registro_mercantil">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Sí
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Aplica Resolución MinTransporte</label>
                  <select class="form-control form-control-sm" id="aplica_resolucion_mintransporte"
                    formControlName="aplica_resolucion_mintransporte">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Sí
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Aplica Sostenibilidad Turística</label>
                  <select class="form-control form-control-sm" id="aplica_sostenibilidad_turistica"
                    formControlName="aplica_sostenibilidad_turistica">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Sí
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Aplica Turismo Aventura</label>
                  <select class="form-control form-control-sm" id="aplica_turismo_aventura"
                    formControlName="aplica_turismo_aventura">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Sí
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Permite Cambio Tipo RNT</label>
                  <select class="form-control form-control-sm" id="permite_cambio_tipo_rnt"
                    formControlName="permite_cambio_tipo_rnt">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Sí
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      No
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Estado</label>
                  <select class="form-control form-control-sm" id="activo" formControlName="activo">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Activo
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      Inactivo
                    </option>
                  </select>
                </div>
                <div class="d-flex flex-row">
                  <button type="reset" class="btn btn-outline-primary border-0 m-auto"
                    (click)="limpiar()">Limpiar</button>
                  <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>


      <div class="table-responsive">
        <app-tablas [page] = "paginaActual" [headers]="headerSubCategoria" [sizeData]="dataTabla.paging.totalItems"
          (paginado)="onPaginado($event)" class="table-responsive">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.descripcion}}</td>
            <td>
              <img src="../../../../../../../assets/icons/ver-eyes.png" class="pointer" alt="" height="25"
                (click)="onOpenModalGenerarHtml(item)">
            </td>
            <td>{{item.descripcion_categoria}}</td>
            <td>{{item.aplica_alojamiento_hospedaje ? 'Sí' : 'No'}}</td>
            <td>{{item.aplica_documento_adjunto ? 'Sí' : 'No'}}</td>
            <td>{{item.aplica_registro_mercantil ? 'Sí' : 'No'}}</td>
            <td>{{item.aplica_resolucion_mintransporte ? 'Sí' : 'No'}}</td>
            <td>{{item.aplica_sostenibilidad_turistica ? 'Sí' : 'No'}}</td>
            <td>{{item.aplica_turismo_aventura ? 'Sí' : 'No'}}</td>
            <td>{{item.permite_cambio_tipo_rnt ? 'Sí' : 'No'}}</td>
            <td>{{item.activo ? 'Activo' : 'Inactivo'}}</td>
            <td class="d-flex flex-row">
              <img src="../../../../../../../assets/icons/ver-eyes.png" class="pointer" alt="" height="25"
                (click)="onOpenModalSubCategoria(item)">
              <img src="../../../../../../../assets/icons/edit.png" class="pointer" alt="" height="25"
                (click)="onCargarSubCategoria(item)">
              <img src="../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25"
                (click)="onEliminarSubCategoria(item)">
            </td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>